import { render, staticRenderFns } from "./ComparisonTable.vue?vue&type=template&id=7c9fd361&scoped=true"
import script from "./ComparisonTable.vue?vue&type=script&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./ComparisonTable.vue?vue&type=style&index=0&id=7c9fd361&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7c9fd361",
  null
  
)

export default component.exports